import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import LedgerPage from "@/pages/LedgerPage";
import RecurringPage from "@/pages/RecurringPage";
import DonorsPage from "@/pages/DonorsPage";
import CategoriesPage from "@/pages/CategoriesPage";
import ReportsPage from "@/pages/ReportsPage";
import SettingsPage from "@/pages/SettingsPage";
import TeamPage from "@/pages/TeamPage";
import AcceptInvitePage from "@/pages/AcceptInvitePage";
import MobileLayout from "@/pages/mobile/MobileLayout";
import MobileHome from "@/pages/mobile/MobileHome";
import CountFormPage from "@/pages/mobile/CountFormPage";
import CashOnHandPage from "@/pages/mobile/CashOnHandPage";
import ServicesLogPage from "@/pages/mobile/ServicesLogPage";
import TreasurerPage from "@/pages/mobile/TreasurerPage";
import LandingPage from "@/pages/LandingPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import MembersPage from "@/pages/MembersPage";
import TermsPage from "@/pages/legal/TermsPage";
import PrivacyPage from "@/pages/legal/PrivacyPage";
import CCPAPage from "@/pages/legal/CCPAPage";
import DoNotSellPage from "@/pages/legal/DoNotSellPage";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/accept-invite/:token" element={<AcceptInvitePage />} />
            <Route path="/legal/terms" element={<TermsPage />} />
            <Route path="/legal/privacy" element={<PrivacyPage />} />
            <Route path="/legal/ccpa" element={<CCPAPage />} />
            <Route path="/legal/dnsmpi" element={<DoNotSellPage />} />

            <Route
              path="/m"
              element={
                <ProtectedRoute>
                  <MobileLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<MobileHome />} />
              <Route path="count" element={<CountFormPage />} />
              <Route path="cash" element={<CashOnHandPage />} />
              <Route path="services" element={<ServicesLogPage />} />
              <Route path="treasurer" element={<TreasurerPage />} />
            </Route>

            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
            </Route>

            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/ledger" element={<LedgerPage />} />
              <Route path="/recurring" element={<RecurringPage />} />
              <Route path="/donors" element={<DonorsPage />} />
              <Route path="/members" element={<MembersPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/categories" element={<Navigate to="/settings?tab=categories" replace />} />
              <Route path="/reports" element={<Navigate to="/settings?tab=reports" replace />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
